<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    <p> Total Skyscrapers {{ skyscrapers.getTotal }}</p>
    <ul>
      <li v-for="skyscraper in skyscrapers.list" :key="skyscraper.id">{{skyscraper.title}}</li>
    </ul>
    <!-- <app-server-status></app-server-status> -->
  </div>
</template>

<script>
import { SKYSCRAPERS } from './graphql.js'

export default {
  apollo: {
    // Simple query that will update the 'hello' vue property
    skyscrapers: {
      query: SKYSCRAPERS,
      update(data) {
        return data.skyscraper
      }
    }
  },
  data: () => ({
    skyscrapers: 'loading'
  })
}
</script>

<style lang="scss">
</style>
